/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentStatus } from './paymentStatus';


export interface PaymentStatusApiModel { 
    id: string;
    paymentStatus: PaymentStatus;
}
export namespace PaymentStatusApiModel {
}


